import { css } from 'lit';

export const ariaOnly = css`
  .aria-only {
    left: -999em;
    opacity: 0;
    position: absolute;
  }
`;
